import { Button, Grid, CircularProgress, Stack } from '@mui/material';
import MDAvatar from 'components/MDAvatar';
import MDBox from 'components/MDBox';
import { Link, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import brandPixcua from 'assets/images/pixcua.png';
import MDTypography from 'components/MDTypography';
import PdfMakeOpenTest from 'pantallas/Comprobantes/Data/acciones/components/PDF/PdfMakeOpenTest';
import PdfMakeComplementoPago from 'pantallas/Comprobantes/Data/acciones/components/PdfMakeComplementoPago/PdfMakeComplementoPago';
import { iComprobante } from 'actions/Comprobante/comprobanteTypes';
import { useEffect, useState } from 'react';
import {
	iMiEmpresaInfoToPDF,
	initMiEmpresaFormulario,
} from 'actions/MiCuenta/miCuentaTypes';
import {
	descargarComprobante,
	getComprobantesById,
} from 'actions/Comprobante/comprobante';
import { getEmpresaInfoById } from 'actions/MiCuenta/miCuenta';
import { useSelector } from 'react-redux';
import { RootStore } from 'store/Store';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import JSZip from 'jszip';

const ComprobanteDescarga = () => {
	const navigate = useNavigate();
	const params = useParams();
  const [searchParams] = useSearchParams();
	const automaticDownload = (searchParams.get('dl') || '').toLowerCase();
	const hasAutomaticDownload = ['xml', 'pdf', 'both'].includes(automaticDownload);
	const automaticDownloadCount = hasAutomaticDownload ? 1 : 0;
	const { authState } = useSelector((state: RootStore) => state.auth);
	const initComprobante: iComprobante = {
		c_regimen_fiscal_Cliente: '',
		c_regimen_fiscal_Empresa: '',
		calle: '',
		cantidad_letra: '',
		certificado: null,
		cliente_id: 0,
		codigo_postal: '0',
		colonia: '',
		comprobantesDetalles: [],
		descuento: 0,
		empresa_id: 0,
		estado: '',
		estatus_comprobante_id: 0,
		fecha: '',
		fecha_timbrado: null,
		folio: 0,
		forma_de_pago: '',
		id: 0,
		isr: null,
		iva: 0,
		localidad: '',
		lugar_expedicion: '',
		metodo_de_pago: '',
		moneda: '',
		motivo_de_descuento: '',
		municipio: '',
		no_certificado: '',
		no_certificado_sat: null,
		no_exterior: '',
		no_interior: '',
		nombre: '',
		num_cta_pago: '',
		pagado: false,
		pais: '',
		referencia: '',
		retencion_isr: 0,
		retencion_iva: 0,
		rfc: '',
		sello: null,
		sello_sat: null,
		serie: '',
		subtotal: 0,
		subtotal_iva_cero: 0,
		tasa: 0,
		timbrado: false,
		tipo_cambio: null,
		tipo_de_comprobante: '',
		tipo_uso: '',
		total: 0,
		uuid: '',
		version: '',
		tipo_relacion_id: null,
		comprobante_relacionado_uuid: null,
	};
	const [comprobante, setComprobante] = useState(initComprobante);
  const [status, setStatus] = useState<'loading' | 'ok' | 'not_found' | 'error'>('loading');
	const [empresaInfo, setEmpresaInfo] = useState<iMiEmpresaInfoToPDF>(
		initMiEmpresaFormulario
	);
	const [pendingAutomaticDownloads, setPendingAutomaticDownloads] = useState(
		automaticDownloadCount
	);
	const [automaticDownloadFailed, setAutomaticDownloadFailed] = useState(false);
	const isAutomaticDownloadInProgress =
		hasAutomaticDownload && pendingAutomaticDownloads > 0;
	const automaticDownloadLabel =
		automaticDownload === 'both'
			? 'XML y PDF'
			: automaticDownload.toUpperCase();

	const finishAutomaticDownload = (success: boolean) => {
		if (!success) setAutomaticDownloadFailed(true);
		setPendingAutomaticDownloads((pending) => Math.max(0, pending - 1));
	};
	//Get comprobanteByUuid
	useEffect(() => {
		//PDF
		const comprobanteData = getComprobantesById(params.uuid);
		comprobanteData
			.then((respuesta) => {
				if (respuesta.status === 200) {
					setComprobante(respuesta.data);
          setStatus('ok');
				}
			})
			.catch((error) => {
				if (error?.response?.status === 404) {
					setStatus('not_found');
				} else if (error?.response?.status === 500) {
					console.log('error500');
					console.log(error.response.data.message);
					setStatus('error');
				} else if (error?.response?.status === 400) {
					console.log('error400');
					console.log(error.response.data.message);
					setStatus('error');
				} else if (error?.response?.status === 401) {
					console.log('error401');
					console.log(error.response.data);
					setStatus('error');
				} else if (error?.response?.status === 403) {
					console.log('error403');
					console.log(error.response.data.message);
					setStatus('error');
				} else {
					console.log(error.response.data.message);
          setStatus('error');
				}
			});
    		//XML (manual o via query param)

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

  // Control por query params para auto-acciones (dl=pdf|xml|both, view=pdf)
  const [shouldDownloadPdf, setShouldDownloadPdf] = useState(false);
  const [shouldViewPdf, setShouldViewPdf] = useState(false);
	const [shouldDownloadZip, setShouldDownloadZip] = useState(false);
	const [isDownloadingXml, setIsDownloadingXml] = useState(false);

  useEffect(() => {
    const dl = (searchParams.get('dl') || '').toLowerCase();
    const view = (searchParams.get('view') || '').toLowerCase();
    if (dl === 'pdf') setShouldDownloadPdf(true);
    if (dl === 'xml') descargarXml(finishAutomaticDownload);
	if (dl === 'both') setShouldDownloadZip(true);
    if (view === 'pdf') setShouldViewPdf(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

	//Get miEmpresaInfo By id
	useEffect(() => {
		if (comprobante.empresa_id) {
			const dataEmpresa = getEmpresaInfoById(comprobante.empresa_id);
			dataEmpresa
				.then((respuesta) => {
					if (respuesta.status === 200) {
						setEmpresaInfo({
							...empresaInfo,
							nombre: respuesta.data.nombre,
							rfc: respuesta.data.rfc,
							codigo_postal: respuesta.data.codigo_postal,
							calle: respuesta.data.calle ? respuesta.data.calle : '',
							no_exterior: respuesta.data.no_exterior
								? respuesta.data.no_exterior
								: '',
							no_interior: respuesta.data.no_interior
								? respuesta.data.no_interior
								: '',
							colonia: respuesta.data.colonia ? respuesta.data.colonia : '',
							localidad: respuesta.data.localidad ? respuesta.data.localidad : '',
							estado: respuesta.data.estado ? respuesta.data.estado : '',
							pais: respuesta.data.pais ? respuesta.data.pais : '',
						});
					}
				})
				.catch((error) => {
					if (error.response.status === 500) {
						console.log('error500');
						console.log(error.response.data.message);
					} else if (error.response.status === 400) {
						console.log('error400');
						console.log(error.response.data.message);
					} else if (error.response.status === 403) {
						console.log('error403');
						console.log(error.response.data.message);
					} else if (error.response.status === 404) {
						console.log('error404');
						console.log(error.response.data.message);
					} else {
						console.log(error.response.data.message);
					}
				});
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [comprobante.empresa_id]);
	const descargarXml = (onComplete?: (success: boolean) => void) => {
		const comprobanteData = descargarComprobante(params.uuid);
		comprobanteData
			.then((respuesta) => {
				console.log(respuesta);
				if (respuesta.status === 200) {
					// setComprobante({ estatus: 'cargado' });
					const url = window.URL.createObjectURL(new Blob([respuesta.data]));
					const link = document.createElement('a');
					link.href = url;
					link.setAttribute('download', `${params.uuid}.xml`);
					document.body.appendChild(link);
					link.click();
					link.remove();
					window.setTimeout(() => window.URL.revokeObjectURL(url), 40_000);
					window.setTimeout(() => onComplete?.(true), 0);
				} else {
					onComplete?.(false);
				}
			})
			.catch((error) => {
				console.log(error);

				if (error.response.status === 500) {
					// setComprobante({ estatus: 'error' });
					console.log('error500');
					console.log(error.response.data.message);
				} else if (error.response.status === 400) {
					// setComprobante({ estatus: 'error' });
					console.log('error400');
					console.log(error.response.data.message);
				} else if (error.response.status === 401) {
					// setComprobante({ estatus: 'error' });
					console.log('error401');
					console.log(error.response.data);
				} else if (error.response.status === 403) {
					// setComprobante({ estatus: 'error' });
					console.log('error403');
					console.log(error.response.data.message);
				} else if (error.response.status === 404) {
					// setComprobante({ estatus: 'error' });
					console.log('error404');
					console.log(error.response.data.message);
				} else {
					// setComprobante({ estatus: 'error' });
					console.log(error.response.data.message);
				}
				onComplete?.(false);
			});
	};
	const descargarZip = async (pdfBlob: Blob) => {
		const respuestaXml = await descargarComprobante(params.uuid);
		if (respuestaXml.status !== 200) {
			throw new Error('No fue posible obtener el XML del comprobante');
		}

		const fileName = String(params.uuid || comprobante.uuid);
		const zip = new JSZip();
		zip.file(`${fileName}.xml`, respuestaXml.data);
		zip.file(`${fileName}.pdf`, pdfBlob);
		const zipBlob = await zip.generateAsync({
			type: 'blob',
			compression: 'DEFLATE',
		});
		const url = window.URL.createObjectURL(zipBlob);
		const link = document.createElement('a');
		link.href = url;
		link.setAttribute('download', `${fileName}.zip`);
		document.body.appendChild(link);
		link.click();
		link.remove();
		window.setTimeout(() => window.URL.revokeObjectURL(url), 40_000);
		await new Promise<void>((resolve) => window.setTimeout(resolve, 0));
	};
	const finishPdfDownload = (success: boolean) => {
		setShouldDownloadPdf(false);
		if (automaticDownload === 'pdf') finishAutomaticDownload(success);
	};
	const finishZipDownload = (success: boolean) => {
		setShouldDownloadZip(false);
		if (automaticDownload === 'both') finishAutomaticDownload(success);
	};
	const startXmlDownload = () => {
		if (isDownloadingXml) return;
		setIsDownloadingXml(true);
		descargarXml(() => setIsDownloadingXml(false));
	};
	const isDocumentDownloadInProgress =
		isAutomaticDownloadInProgress ||
		isDownloadingXml ||
		shouldDownloadPdf ||
		shouldDownloadZip;
	const documentDownloadLabel = isDownloadingXml
		? 'XML'
		: shouldDownloadZip
		? 'XML y PDF en formato ZIP'
		: shouldDownloadPdf
		? 'PDF'
		: automaticDownloadLabel;
	const atras = () => {
		navigate(-1);
	};
	return (
		<>
			<MDBox pt={4} pb={3}>
				{authState.isAutenticated && (
					<Button
						color='primary'
						variant='contained'
						startIcon={<ArrowBackIosIcon style={{ color: '#fff' }} />}
						style={{ backgroundColor: '#00ACC8', color: '#fff', marginLeft: '10px' }}
						onClick={atras}
					>
						regresar
					</Button>
				)}
				<Grid container justifyContent='center' alignItems='center'>
					<MDAvatar
						variant='square'
						style={{ marginTop: '2rem', width: '9rem' }}
						src={brandPixcua}
						alt='Avatar'
					/>
				</Grid>
				{status === 'loading' && (
					<MDBox pt={4} mt={5} textAlign='center'>
						<CircularProgress size={28} color='primary' />
						<MDTypography variant='h6' color='text' mt={1}>
							Cargando comprobante...
						</MDTypography>
					</MDBox>
				)}

				{status === 'ok' && comprobante.uuid ? (
					<MDBox
						pt={4}
						mt={5}
						textAlign='center'
						// display={'flex'}
						// flexDirection={'column'}
					>
						<MDTypography variant='h4' fontWeight='medium' color='text'>
							Descarga aquí tu comprobante:
						</MDTypography>
                    <MDTypography variant='h4' fontWeight='medium' color='text' mb={5}>
                        {comprobante.uuid}
                    </MDTypography>
                    {comprobante.uuid && shouldDownloadPdf && (
						<PdfMakeOpenTest
							uuid={comprobante.uuid}
							tipo={'descargar'}
							id={comprobante.id}
							autoOpen
							onAutoActionComplete={finishPdfDownload}
						/>
                    )}
						{comprobante.uuid && shouldDownloadZip && (
							<PdfMakeOpenTest
								uuid={comprobante.uuid}
								tipo={'blob'}
								id={comprobante.id}
								autoOpen
								onPdfBlobReady={descargarZip}
								onAutoActionComplete={finishZipDownload}
							/>
						)}
						{comprobante.uuid && shouldViewPdf && (
							<PdfMakeOpenTest uuid={comprobante.uuid} tipo={'abrir'} id={comprobante.id} autoOpen />
						)}
						{(hasAutomaticDownload || isDocumentDownloadInProgress) && (
							<MDBox mb={3}>
								{isDocumentDownloadInProgress && <CircularProgress size={24} color='primary' />}
								<MDTypography variant='h6' color='text' mt={1}>
									{isDocumentDownloadInProgress
										? `Preparando descarga de ${documentDownloadLabel}...`
										: automaticDownloadFailed
										? 'No fue posible iniciar la descarga. Intente nuevamente.'
										: 'La descarga se inició. Revise las descargas de su navegador.'}
								</MDTypography>
							</MDBox>
						)}
            <Stack
              mt={2}
              spacing={2}
              direction={{ xs: 'column', sm: 'row' }}
              justifyContent='center'
              alignItems='center'
              sx={{ width: '100%', maxWidth: 520, mx: 'auto' }}
            >
              <Button
                variant='contained'
                color='primary'
				disabled={isDocumentDownloadInProgress}
				onClick={() => setShouldDownloadZip(true)}
                sx={{ width: { xs: '100%', sm: 'auto' } }}
              >
				Descargar ZIP
              </Button>
              <Button
				variant='outlined'
                color='primary'
				disabled={isDocumentDownloadInProgress}
                onClick={() => setShouldDownloadPdf(true)}
                sx={{ width: { xs: '100%', sm: 'auto' } }}
              >
				Descargar PDF
              </Button>
              <Button
                variant='outlined'
                color='primary'
				disabled={isDocumentDownloadInProgress}
				onClick={startXmlDownload}
                sx={{ width: { xs: '100%', sm: 'auto' } }}
              >
				Descargar XML
              </Button>
            </Stack>
					</MDBox>
				) : null}

				{status === 'not_found' && (
					<MDBox pt={4} mt={5} textAlign='center'>
						<MDTypography variant='h4' fontWeight='medium' color='text'>
							Comprobante no encontrado
						</MDTypography>
						<MDTypography variant='button' color='text'>
							Revise el UUID o contacte a soporte si persiste.
						</MDTypography>
					</MDBox>
				)}

				{status === 'error' && (
					<MDBox pt={4} mt={5} textAlign='center'>
						<MDTypography variant='h4' fontWeight='medium' color='text'>
							Ocurrió un error al cargar el comprobante
						</MDTypography>
						<MDTypography variant='button' color='text'>
							Intente nuevamente en unos momentos.
						</MDTypography>
					</MDBox>
				)}
			</MDBox>
		</>
	);
};

export default ComprobanteDescarga;
